 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		15: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		15: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"1bfc9850","2":"252f366e","3":"commons","4":"0c428ae2","5":"0e910002b05e53375c003b20f4ad92ae7079c861","6":"513a9c1def5cffa1ec6c74b40787d27f7a3e7ff6","7":"78e521c3","8":"01a551e08490cbf865419767a2a48b381d160b07","9":"711ea24a87192671427a03113b61f0c64c2cc4a9","10":"95b64a6e","11":"6183f454d7189cefcc61a457bc4bd9caf3ae8c1e","12":"a00b02a0","13":"a1af805f9cd5d0551e6a2d63c5faa76e732e0612","14":"bd73a8745c80610a3eb2227d6d47e80b775bdada","16":"1a48c3c1","18":"component---src-pages-404-tsx","19":"component---src-pages-contact-tsx","20":"component---src-pages-index-tsx","21":"component---src-pages-orthodontist-tsx","22":"component---src-pages-our-practice-tsx","23":"component---src-pages-our-team-tsx","24":"component---src-pages-patient-information-emergencies-tsx","25":"component---src-pages-patient-information-faq-tsx","26":"component---src-pages-patient-information-first-visit-tsx","27":"component---src-pages-patient-information-foods-and-habits-to-avoid-tsx","28":"component---src-pages-patient-information-index-tsx","29":"component---src-pages-patient-information-patient-form-tsx","30":"component---src-pages-patient-information-payment-information-tsx","31":"component---src-pages-privacy-policy-tsx","32":"component---src-pages-referral-tsx","33":"component---src-pages-service-policy-tsx","34":"component---src-pages-terms-conditions-tsx","35":"component---src-pages-what-we-do-braces-tsx","36":"component---src-pages-what-we-do-clear-aligners-tsx","37":"component---src-pages-what-we-do-clear-braces-tsx","38":"component---src-pages-what-we-do-early-treatment-tsx","39":"component---src-pages-what-we-do-index-tsx","40":"component---src-pages-what-we-do-surgical-orthodontics-tsx","41":"component---src-pages-who-we-are-tsx","42":"d7eeaac4"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"4f6c2188b4b7b36fd7d9","2":"06b517236378ce9708bc","3":"d5a65e6c9fffefb06f33","4":"6a17806811e7798fa112","5":"d664d936d99c6c2c478d","6":"c0a6acdbce5e7d45a0d5","7":"85f9b32073c4e5f4e1c1","8":"5e161b464c69ab6d14f4","9":"f0b3e77b168659647345","10":"5e5ee9580887722a1274","11":"197899608e91c56d96de","12":"78ab6784d5bfeba51925","13":"1044e8205731d74877e3","14":"4c8333fe1b7007706635","16":"76a6b469d4ff6d30b1d3","18":"ed579ad3c99c891dfcc0","19":"599a2351756bc0772d81","20":"414b38b247885cb8edd5","21":"dcffec8c3d072ce5e58f","22":"6337f03a9d56cafdec05","23":"3898779a0dc1e611212f","24":"4de033fc4d779ad8e77d","25":"05e88ba39686fc7ff35c","26":"a0ca1ecbdd405e15bbd7","27":"afe5f971f4b7b0372350","28":"b801253b975071d33fbe","29":"32b305080b9b9c7dca3a","30":"f484f4c1159295ab628f","31":"d90e5fb8ce334119e4f8","32":"12fcfe80e30201cffdcc","33":"3fbe26ae392b5798f3ba","34":"7665466412401fb5f0da","35":"73d63bdaa980dd775894","36":"0fbba8862799764cdbfa","37":"9e2f34a66c3c5bc245ea","38":"e39e25dded0ea8e02284","39":"80ed8be5cea51ae0568e","40":"b3696d371bdc61658017","41":"65e330375878ebf6a045","42":"45b9365924bf255d8f37"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"1bfc9850","2":"252f366e","3":"commons","4":"0c428ae2","5":"0e910002b05e53375c003b20f4ad92ae7079c861","6":"513a9c1def5cffa1ec6c74b40787d27f7a3e7ff6","7":"78e521c3","8":"01a551e08490cbf865419767a2a48b381d160b07","9":"711ea24a87192671427a03113b61f0c64c2cc4a9","10":"95b64a6e","11":"6183f454d7189cefcc61a457bc4bd9caf3ae8c1e","12":"a00b02a0","13":"a1af805f9cd5d0551e6a2d63c5faa76e732e0612","14":"bd73a8745c80610a3eb2227d6d47e80b775bdada","16":"1a48c3c1","18":"component---src-pages-404-tsx","19":"component---src-pages-contact-tsx","20":"component---src-pages-index-tsx","21":"component---src-pages-orthodontist-tsx","22":"component---src-pages-our-practice-tsx","23":"component---src-pages-our-team-tsx","24":"component---src-pages-patient-information-emergencies-tsx","25":"component---src-pages-patient-information-faq-tsx","26":"component---src-pages-patient-information-first-visit-tsx","27":"component---src-pages-patient-information-foods-and-habits-to-avoid-tsx","28":"component---src-pages-patient-information-index-tsx","29":"component---src-pages-patient-information-patient-form-tsx","30":"component---src-pages-patient-information-payment-information-tsx","31":"component---src-pages-privacy-policy-tsx","32":"component---src-pages-referral-tsx","33":"component---src-pages-service-policy-tsx","34":"component---src-pages-terms-conditions-tsx","35":"component---src-pages-what-we-do-braces-tsx","36":"component---src-pages-what-we-do-clear-aligners-tsx","37":"component---src-pages-what-we-do-clear-braces-tsx","38":"component---src-pages-what-we-do-early-treatment-tsx","39":"component---src-pages-what-we-do-index-tsx","40":"component---src-pages-what-we-do-surgical-orthodontics-tsx","41":"component---src-pages-who-we-are-tsx","42":"d7eeaac4"}[chunkId]||chunkId) + "." + {"0":"e45a74598bc3fa540bdc","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
